import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatAltTag',
})
export class FormatAltTagPipe implements PipeTransform {
  public transform(value: string, seasonNumber: number, episodeNumber: number): unknown {
    const season = `${seasonNumber ? ` - S${seasonNumber}` : ''}`;
    const episode = `${episodeNumber ? `:E${episodeNumber}` : ''}`;
    return `${value}${season}${episode}`;
  }
}
